import React from 'react';
// template components
import Carousel from '@nmx/template/dist/componentLibrary/modules/Carousel';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// style imports
import { ColStyled } from './styles';

const config = {
  swiperCarousel: {
    autoplay: false, // boolean // auto-rotate slides
    autoplayDelay: 5000, // slide transition time
    isActive: true,
    slides: [
      {
        data: {
          heading: 'Staying in Practice', // optional heading
          text: '', // optional supporting text
          videoId: 'q72Ci5Dehes',
        },
      },
      {
        data: {
          heading: 'Starting Fresh', // optional heading
          text: '', // optional supporting text
          videoId: '9WMi2GoCuok',
        },
      },
    ],
  },
};

export default () => (
  <SectionContainer
    id='testimonials-financial-planning' // '-section-container' will be appended dynamically
    backgroundVariant='lightB'
    className='nmx-no-print'
    themeType='lightTheme'
    moduleName='testimonials-module'
    moduleVariation='A'
    disableBottomPadding>
    <Row align='center'>
      <Col
        align='center'
        medium={10}
        large={8}>
        <Typography component='h2' nextElement='typography'>
          Doctors and dentists tell their disability <WidowBlock>insurance stories</WidowBlock>
        </Typography>
        <Typography nextElement='graphic'>
          Hear how Northwestern Mutual helped these practitioners plan for the unexpected.
        </Typography>
      </Col>
    </Row>
    <Row align='center'>
      <ColStyled>
        <Carousel
          data-app-name='demo'
          data-static-config={config}
        />
      </ColStyled>
    </Row>
  </SectionContainer>
);
